document.addEventListener('DOMContentLoaded', function () {
    const counter = document.querySelector('.countdown-banner__weekly .countdown-timer');
    const dayField = counter.querySelector('.days span');
    const hourField = counter.querySelector('.hours span');
    const minField = counter.querySelector('.minutes span');
    const secField = counter.querySelector('.seconds span');

    let currentDate = new Date();
    let deadLine = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()+(7 - currentDate.getUTCDay()), 10, 00, 00);
    
    function getTimeRemaining(endtime){
        let t = Date.parse(endtime) - Date.parse(new Date());
        let days = Math.floor( t/(1000*60*60*24) );
        let hours = Math.floor( (t/(1000*60*60)) % 24 );
        let minutes = Math.floor( (t/1000/60) % 60 );
        let seconds = Math.floor( (t/1000) % 60 );
        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        };
    }

    function updateClock(){
        let t = getTimeRemaining(deadLine);
        dayField.innerHTML = ('0' + t.days).slice(-2);  
        hourField.innerHTML = ('0' + t.hours).slice(-2);  
        minField.innerHTML = ('0' + t.minutes).slice(-2);  
        secField.innerHTML = ('0' + t.seconds).slice(-2);
        
        if(t.total<=0){
            clearInterval(timeinterval);
        }  
    }
    
    updateClock(); // запускаем один раз чтобы не было задержки  
    let timeinterval = setInterval(updateClock, 1000);
});
